import React from "react";
import { NumericFormat } from "react-number-format";

interface NumberFormatProps {
  total: number;
}

const NumberFormat: React.FC<NumberFormatProps> = ({ total }) => {
  return (
    <NumericFormat
      value={total}
      displayType={"text"}
      thousandSeparator={true}
      thousandsGroupStyle="lakh"
      decimalSeparator={"."}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
};

export default NumberFormat;
